import { useRef, useState } from "react";
import { nextStatus } from "@/lib/mobile";
import { OrderList, OrderToolbar } from "./OrderList";
import { EmptyDetail, OrderDetail } from "./OrderDetail";
import { groupOf, isDone } from "./status";

const match = (o, t) => !t || o.customer.name.toLowerCase().includes(t) || String(o.number).includes(t.replace("#", ""));

export function OrdersBoard({ orders, steps, ...props }) {
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("");
  const [selected, setSelected] = useState(null);
  const detailRef = useRef(null);
  const t = q.trim().toLowerCase();
  const list = orders.filter((o) => (filter ? groupOf(o) === filter : t ? true : !isDone(o)) && match(o, t));
  const sel = orders.find((o) => o.id === selected);
  const pick = (id) => {
    setSelected(id);
    if (window.innerWidth < 1024) setTimeout(() => detailRef.current?.scrollIntoView({ behavior: "smooth" }), 50);
  };
  return (
    <div className="space-y-3" data-testid="orders-board">
      <OrderToolbar q={q} setQ={setQ} orders={orders} filter={filter} setFilter={setFilter} />
      <div className="grid gap-3 lg:h-[calc(100vh-15rem)] lg:min-h-[520px] lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <OrderList list={list} selected={selected} onSelect={pick} filtered={!!(t || filter)} />
        <div ref={detailRef} className="min-h-0">
          {sel ? <OrderDetail key={sel.id} o={sel} next={nextStatus(sel, steps)} {...props} /> : <EmptyDetail />}
        </div>
      </div>
    </div>
  );
}
